import { gql, useQuery } from '@apollo/client';
export const FEATURE_ACCESS = gql`query FeatureAccess { featureAccess { ethiopianCalendar } }`;
export const SUPPORTED_COUNTRIES = gql`query SupportedCountries { supportedCountries { id name code } }`;
export function useFeatureAccess() {
  const result = useQuery(FEATURE_ACCESS, { fetchPolicy: 'cache-and-network', pollInterval: 30000 });
  return { ...result, ethiopianEnabled: result.data?.featureAccess?.ethiopianCalendar === true };
}
export function useSupportedCountries() {
  const result = useQuery(SUPPORTED_COUNTRIES, { fetchPolicy: 'cache-and-network' });
  return { ...result, countries: result.data?.supportedCountries || [] };
}
